import { styled } from "@mui/material/styles"

export const Container = styled("div")({
    display: "flex",
    flexDirection: "column",
})

type StyledContentProps = {
    maxHeight: number | "none",
    fontSize: number,
}

export const Content = styled("div", { shouldForwardProp: (prop) => prop !== "maxHeight" && prop !== "fontSize" })<StyledContentProps>(({ maxHeight, fontSize }) => ({
    overflow: "hidden",
    maxHeight: maxHeight,
    transition: "max-height 0.3s ease",
    fontSize: fontSize,
}))